const PersonalizationMixinsProps = {
  props: {
    value: {
      type: Object,
      required: null,
    },
    price: {
      type: Number,
      required: false,
      default: 0,
    },
    pet: {
      type: Object,
      default: null,
      required: false,
    },
    petOwner: {
      type: Object,
      default: null,
      required: false,
    },
    petKnown: {
      type: Boolean,
      default: false,
    },
    isLoggedIn: {
      type: Boolean,
      default: true,
    },
    hidePreview: {
      type: Boolean,
      default: false,
    },
    previewOnly: {
      type: Boolean,
      default: false,
    },
    previewShowLabels: {
      type: Boolean,
      default: true,
    },
    previewHeight: {
      type: Number,
      default: 400,
    },
    previewScale: {
      type: Number,
      default: 0.8,
    },
    baseSvgImgPath: {
      type: [String, Boolean],
      default: false,
      required: false,
    },
    defaultPhoneNumber: {
      type: [Number, String],
      default: '',
      required: true,
    },
    isAdmin: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
};

const PersonalizationMixinsData = {
  data() {
    return {
      personalizationDetails: this.value,
      dropDownPetNameSelected: true,
      dropDownPhoneNumberSelected: true,
    };
  },
};

const PersonalizationMixinsComputed = {
  computed: {
    phoneNumberOptions() {
      const options = [{ value: '', text: 'Select Phone Number' }];
      if (this.petOwner) {
        if (this.petOwner.validatedPhone) {
          options.push({
            value: this.petOwner.validatedPhone,
            text: `Home: ${this.phoneNumberFormatter(this.petOwner.validatedPhone)}`,
          });
        }
        if (this.petOwner.validatedCellPhone) {
          options.push({
            value: this.petOwner.validatedCellPhone,
            text: `Mobile: ${this.phoneNumberFormatter(this.petOwner.validatedCellPhone)}`,
          });
        }
        if (this.petOwner.validatedWorkPhone) {
          options.push({
            value: this.petOwner.validatedWorkPhone,
            text: `Work: ${this.phoneNumberFormatter(this.petOwner.validatedWorkPhone)}`,
          });
        }
      }
      options.push(
        {
          value: this.defaultPhoneNumber?.toString()?.replaceAll('-', ''),
          text: `HomeSafe®: 1-${this.phoneNumberFormatter(this.defaultPhoneNumber)}`,
        },
        { value: 'EnterContactNumber', text: 'Enter your phone number' }
      );
      return options;
    },
    formattedValue() {
      return this.phoneNumberFormatter(this.personalizationDetails.phone);
    },
    selectedPet() {
      if (!this.personalizationDetails?.name || !this.petOwner) return null;
      return this.petOwner?.pets?.find((pet) => pet.name?.toLowerCase()?.startsWith(this.personalizationDetails?.name?.toLowerCase()));
    },
  },
};

const PersonalizationMixinsMethods = {
  methods: {
    onPersonalizationSelectionChange() {
      if (this.personalizationDetails?.selected === true) {
        if (!this.personalizationDetails?.editTag) {
          if (this.petKnown && this.pet) {
            this.setName(this.pet?.name);
          } else if (['Found me?', '(Pet Name)'].includes(this.personalizationDetails?.name)) {
            this.dropDownPetNameSelected = true;
            this.personalizationDetails.name = '';
          }
          if (
            (this.phoneNumberOptions?.length > 2 && !this.personalizationDetails.phone) ||
            this.personalizationDetails.phone === this.defaultPhoneNumber?.toString()?.replaceAll('-', '')
          ) {
            this.setPhone(this.petOwner?.primaryPhone || this.defaultPhoneNumber?.toString()?.replaceAll('-', ''));
          }
        }
        this.dropDownPetNameSelected = !(
          this.personalizationDetails?.name &&
          this.petNameOptions?.findIndex(({ value }) => `${this.personalizationDetails?.name.slice(0, 9)}` === value) === -1
        );
        this.dropDownPhoneNumberSelected = !(
          this.personalizationDetails?.phone &&
          this.phoneNumberOptions?.findIndex(({ value }) => this.personalizationDetails?.phone === value) === -1
        );
      } else {
        this.dropDownPetNameSelected = true;
        this.dropDownPhoneNumberSelected = true;
      }
      this.adjustValid();
    },
    handlePetNameSelect() {
      if (this.personalizationDetails.name === 'EnterPetName') {
        this.dropDownPetNameSelected = false;
        this.personalizationDetails.name = '';
      } else {
        this.dropDownPetNameSelected = true;
        this.setName(this.personalizationDetails.name);
      }
    },
    handleContactNumberSelect() {
      if (this.personalizationDetails.phone === 'EnterContactNumber') {
        this.dropDownPhoneNumberSelected = false;
        this.personalizationDetails.phone = '';
      } else {
        this.dropDownPhoneNumberSelected = true;
        this.setPhone(this.personalizationDetails.phone);
      }
    },
    adjustValid() {
      if (this.personalizationDetails?.selected === null) {
        this.personalizationDetails.name = '(Pet Name)';
        this.personalizationDetails.valid = false;
      } else if (!this.personalizationDetails?.selected) {
        this.personalizationDetails.name = 'Found me?';
        this.personalizationDetails.phone = this.defaultPhoneNumber?.toString()?.replaceAll('-', '');
        this.personalizationDetails.valid = true;
      } else if (
        (this.petKnown && this.personalizationDetails?.name?.length > 0 && this.personalizationDetails?.phone?.length === 10) ||
        !this.petKnown
      ) {
        if (this.dropDownPetNameSelected && this.selectedPet) {
          this.$emit('assignToPet', this.selectedPet);
        }
        this.personalizationDetails.valid = true;
      } else {
        this.personalizationDetails.valid = false;
      }
      this.$emit('input', this.personalizationDetails);
    },
    setName(name) {
      this.personalizationDetails.name = name;
      this.adjustValid();
    },
    setPhone(phone) {
      this.personalizationDetails.phone = phone.replace(/[^\d]/g, '');
      this.adjustValid();
    },
    phoneNumberFormatter(phone) {
      if (phone && phone.length > 0) {
        let x = phone.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
        return !x[2] ? x[1] : x[1] + '-' + x[2] + (x[3] ? '-' + x[3] : '');
      }
    },
  },
};

export const PersonalizationMixins = {
  ...PersonalizationMixinsProps,
  ...PersonalizationMixinsData,
  ...PersonalizationMixinsComputed,
  ...PersonalizationMixinsMethods,
};
